module.exports = __webpack_public_path__ + "static/assets/f534383d71dfc171f2ab86c3fc108aff.svg";